import styled, { css } from "styled-components";
import DefaultRow from "components/Form/Row";

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  ${({ width, marginLeft }: { width?: string, marginLeft?: string }) =>
    css`
      width: ${width ?? "100%"};
      margin-left: ${marginLeft ?? "0px"};
    `}
`;

export const Row = styled(DefaultRow)`
  gap: 20px;
  ${({
    width,
    height,
    marginTop,
  }: {
    width?: string,
    height?: string,
    marginTop?: string,
  }) =>
    css`
      width: ${width ?? "100%"};
      height: ${height ?? "100%"};
      margin-top: ${marginTop ?? "0px"};
    `}
`;

export const ControlsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 40px;
`;

export const ControlContainer = styled.div`
  ${({ width }: { width?: string }) =>
    css`
      width: ${width ?? "120px"};
    `}
  &:not(:last-child) {
    margin-right: 32px;
  }
`;
